export { saveAs as save } from 'file-saver'

export function determineFileName (headers) {
  /**
   * The endpoint explicitly adds content-disposition (with filename). We
   * want to extract the filename from the content-disposition headers.
   *
   * Ref: https://stackoverflow.com/a/40940790
   */
  const disposition = headers['content-disposition']
  const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition)
  /**
   * If we error here, content-disposition or regex is wrong. Shouldn't though!
   */
  if (!matches || !matches[1]) {
    return null
  }
  return matches[1].replace(/['"]/g, '').replace(/[+]/g, ' ')
}

export function determineMimeType ({ backupFileName, mimeType }) {
  const extensions = {
    'application/zip': '.zip',
    'application/pdf': '.pdf',
    'text/csv': '.csv'
  }
  const extension = extensions[mimeType.split(';')[0]] || ''
  return `${backupFileName}${extension}`
}
